<div *ngIf="value && value.length">
  <div *ngFor="let item of value" class="product-tree-btn" (click)="onClick(item)">
    {{item}}
  </div>
</div>
